/******************************************************************************************
 *	Logout Controller
 ******************************************************************************************/
(function() {
  angular.module('rcControllers.logout', []).controller(
    'LogoutController',
    /* @ngInject */
    function(
      appReady,
      Auth,
      CustomerSegments,
      BreadcrumbsMenu,
      SelectedCustomer,
      DemoMode,
      SessionStorage
    ) {
      //Reset customer segment counters, to prevent them from persisting between different logins
      CustomerSegments.resetCounters();

      //Remove reseller org name from breadcrumbs
      //Otherwise a RTM or RA who logs in would see the previously set one by a LA
      BreadcrumbsMenu.clearPersistentItems();

      //Clear Selected customer so that it's not persisted between logins
      SelectedCustomer.clear();

      //Clear any SessionStored data
      SessionStorage.clear();

      if (DemoMode.isEnabled()) {
        DemoMode.disable();
      } else {
        appReady.promise.then(Auth.logout());
      }
    }
  );
})();
